"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactSelect = _interopRequireDefault(require("react-select"));

var _isEqual = _interopRequireDefault(require("lodash/isEqual"));

var _selectStyles = _interopRequireDefault(require("../styles/selectStyles"));

var _Label = _interopRequireDefault(require("./Label"));

var _Errors = _interopRequireDefault(require("./Errors"));

var _validateInput = _interopRequireDefault(require("../validations/validateInput"));

var _FieldDescription = _interopRequireDefault(require("../../FieldDescription"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var SelectInput = function SelectInput(props) {
  var id = props.id,
      value = props.value,
      onChange = props.onChange,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$errors = props.errors,
      errors = _props$errors === void 0 ? [] : _props$errors,
      _props$customLabel = props.customLabel,
      customLabel = _props$customLabel === void 0 ? false : _props$customLabel,
      validations = props.validations,
      _props$handleKeyPress = props.handleKeyPress,
      handleKeyPress = _props$handleKeyPress === void 0 ? function () {} : _props$handleKeyPress,
      isOpen = props.isOpen,
      _props$menuPlacement = props.menuPlacement,
      menuPlacement = _props$menuPlacement === void 0 ? 'bottom' : _props$menuPlacement,
      dependencies = props.dependencies,
      t = props.t,
      fieldDescription = props.fieldDescription,
      labelTooltip = props.labelTooltip,
      validationDependency = props.validationDependency,
      errorHandler = props.errorHandler,
      _props$options = props.options,
      options = _props$options === void 0 ? [] : _props$options,
      _props$isMulti = props.isMulti,
      isMulti = _props$isMulti === void 0 ? false : _props$isMulti,
      isLoading = props.isLoading,
      styles = props.styles,
      _props$customValidati = props.customValidations,
      customValidations = _props$customValidati === void 0 ? {} : _props$customValidati,
      customPlaceholder = props.customPlaceholder,
      isFirstInput = props.isFirstInput,
      noFocus = props.noFocus,
      postErrors = props.postErrors,
      postErrorHandler = props.postErrorHandler,
      closeMenuOnScroll = props.closeMenuOnScroll,
      _props$isClearable = props.isClearable,
      isClearable = _props$isClearable === void 0 ? true : _props$isClearable,
      requiredSelection = props.requiredSelection,
      requiredSelectionErrorMessage = props.requiredSelectionErrorMessage;
  var selectRef = (0, _react.useRef)(null);
  var validationDepKey, validationDepValue;

  var _useState = (0, _react.useState)(isOpen),
      _useState2 = _slicedToArray(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  if (validationDependency) {
    var _Object$values$;

    validationDepKey = Object.keys(validationDependency)[0];
    validationDepValue = (_Object$values$ = Object.values(validationDependency)[0]) === null || _Object$values$ === void 0 ? void 0 : _Object$values$.toString();
  }

  var validationsArray = dependencies && dependencies[validationDepKey] && dependencies[validationDepKey][validationDepValue] ? [].concat(_toConsumableArray(dependencies[validationDepKey][validationDepValue]), _toConsumableArray(validations || [])) : validations;

  if (requiredSelection) {
    validationsArray.push('REQUIRED_SELECTION');
  }

  (0, _react.useEffect)(function () {
    if (validationsArray) {
      inputValidation(value);
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [value, validations === null || validations === void 0 ? void 0 : validations.length]);
  (0, _react.useEffect)(function () {
    if (selectRef.current && isFirstInput && !noFocus) {
      selectRef.current.focus();
    }
  }, [isFirstInput]);

  var _options = (options === null || options === void 0 ? void 0 : options.map(function (option) {
    return _objectSpread(_objectSpread({}, option), {}, {
      label: option.label
    });
  })) || [];

  (0, _react.useEffect)(function () {
    if (dependencies) {
      inputValidation(value);
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [validationDepValue]);

  var inputValidation = function inputValidation(valueToCheck) {
    (0, _validateInput.default)({
      value: valueToCheck,
      validations: validationsArray,
      validationDependency: validationDepValue,
      customValidations: customValidations,
      errorHandler: errorHandler,
      dependencies: dependencies,
      requiredSelection: requiredSelection,
      requiredSelectionErrorMessage: requiredSelectionErrorMessage,
      id: id
    });
  };

  var inputChangeHandler = function inputChangeHandler(id, val) {
    if (postErrors) {
      postErrorHandler(id);
    }

    var valueToSave = isMulti ? val && val.map(function (obj) {
      return obj.value;
    }) : val;
    onChange(id, valueToSave);
  };

  var getValue = function getValue() {
    if (!value && value !== 0) {
      return null;
    } else if (isMulti) {
      var getArray = function getArray(x) {
        if (Array.isArray(x)) return x;else {
          var _value = [];

          try {
            _value = getArray(JSON.parse(x));
          } finally {
            return _value;
          }
        }
      };

      return _options.filter(function (option) {
        return getArray(value).find(function (val) {
          return val == option.value;
        });
      });
    } else {
      return _options.find(function (option) {
        return option.value == (value instanceof Object ? value.identifier || value.value : value);
      });
    }
  };

  var menuIsOpen = open && !value && (_options === null || _options === void 0 ? void 0 : _options.length) && {
    menuIsOpen: true
  };
  var portalProps = typeof closeMenuOnScroll === 'function' ? {
    closeMenuOnScroll: closeMenuOnScroll,
    menuPortalTarget: document.body
  } : {};
  return _react.default.createElement(_react.default.Fragment, null, customLabel && _react.default.createElement(_Label.default, {
    customLabel: customLabel,
    tooltip: labelTooltip
  }), fieldDescription && _react.default.createElement(_FieldDescription.default, {
    value: fieldDescription
  }), _react.default.createElement(_reactSelect.default, _extends({}, menuIsOpen && menuIsOpen, {
    ref: selectRef,
    isMulti: isMulti,
    isClearable: isClearable,
    styles: Object.assign(_selectStyles.default, styles && styles),
    onChange: function onChange(val) {
      return inputChangeHandler(id, val);
    },
    options: _options,
    value: getValue(),
    isDisabled: disabled,
    placeholder: customPlaceholder,
    menuPlacement: menuPlacement,
    onKeyDown: function onKeyDown(e) {
      return handleKeyPress && handleKeyPress(e);
    },
    onMenuClose: function onMenuClose() {
      return setOpen(false);
    },
    isLoading: isLoading,
    id: id
  }, portalProps)), _react.default.createElement(_Errors.default, {
    errors: postErrors ? [].concat(_toConsumableArray(errors), [postErrors.message]) : errors,
    t: t
  }));
};

var _default = _react.default.memo(SelectInput, _isEqual.default);

exports.default = _default;